import React from 'react';
import PropTypes from 'prop-types';
import FetchSelect from './FetchSelect';

const LocaleSelect = (props) => (
  <FetchSelect
    label={props.label}
    resultTransformer={{
      [props.textFunc ? 'textFunc' : 'text']: props.textFunc ? props.textFunc : 'key',
      value: 'key',
    }}
    onChange={props.onChange}
    required={props.required}
    disabled={props.disabled}
    errorText={props.errorText}
    value={props.value}
    url="/locales"
    formItemStyle={props.formItemStyle}
    resultFilter={props.resultFilter}
  />
);

LocaleSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  formItemStyle: PropTypes.object,
  textFunc: PropTypes.func,
  resultFilter: PropTypes.func,
};

LocaleSelect.defaultProps = {
  label: 'Locale',
  disabled: false,
  required: false,
  value: null,
  errorText: null,
  formItemStyle: {},
};

export default LocaleSelect;
